import React, { useState, useContext } from "react";
import Swal from "sweetalert2";
import "./ActivateAc.css";
import NavbarCustom from "../../../Components/NavbarCustom";
import CompanyLogo from "../../../Assets/Images/company_logo.png";
import { useNavigate } from "react-router-dom";
import { ParentContext } from "../../../APIContext/ParentContext";

const ActivateAc = () => {
  const navigate = useNavigate();
  const { addParentExisting } = useContext(ParentContext);

  const [processing, setProcessing] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const params = new URLSearchParams(window.location.search);
  const tokenp = params.get("token");

  const handleAddCard = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please fill all fields",
      });
      return;
    }

    if (password !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Password Mismatch",
        text: "Passwords do not match",
      });
      return;
    }

    try {
      setProcessing(true);

      // API CALL HERE
      // await resetPasswordAPI(password)

      const data = {
        token: tokenp,
        password: password,
      };

      await addParentExisting(data); // demo delay
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
      });
    } finally {
      setProcessing(false);
    }
  };

  return (
    <>
      <NavbarCustom />

      <div className="reset-pass-container add-card-for-self-pay">
        <div className="company-logo">
          <img
            className="company-logo-img"
            src={CompanyLogo}
            alt="company_logo"
          />
        </div>
        <form className="reset-pass-form" onSubmit={handleAddCard}>
          <h4 className="reset-pass-title black-text-clip">
            Create Your New Password
          </h4>

          <div className="reset-pass-group">
            <div className="reset-pass-card-element">
              <div className="reset-pass-element">
                <label className="black-text-clip">Password</label>
                <input
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              <div className="reset-pass-element">
                <label className="black-text-clip">Confirm Password</label>
                <input
                  type="password"
                  placeholder="Confirm password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="reset-pass-btn-group">
            <button
              type="submit"
              disabled={processing}
              className="reset-pass-btn reset-pass-btn-orange"
            >
              {processing ? "Resetting..." : "Reset Password"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ActivateAc;
